// Feature flags of the user's agency, served by /users/me/ (backend: agencies/features.py).
// Missing flags (e.g. cached session before the field existed) mean full access.
export const FEATURE_SERSEO_CONTENT = "serseo_content";
export const FEATURE_RECURRING_PROJECTS = "recurring_projects";
// true: bono base semestral; false: solo horas compradas. Se compran siempre con Stripe desde Horas de tickets
export const FEATURE_HOUR_PACKAGE = "hour_package";
// Espejo de BILLING_PLANS_ENABLED (backend): sin él no se ven ni se contratan planes ni plazas
export const PLANS_ON_SALE = false;
// Informes mensuales (generar, enviar y ver, agencia y cliente) y Métricas del cliente
export const FEATURE_CLIENT_REPORTING = "client_reporting";

export const hasAgencyFeature = (user, feature) => user?.agencyFeatures?.[feature] !== false;

export const getMaxClients = (user) => user?.agencyFeatures?.max_clients ?? null;

export const DEMO_BOOKING_URL = "https://reuniones.clientify.com/#/serseomarketing/markezy?v2=true";

export const isExternalAgency = (user) => user?.agencyType === "external";

// `agency_plan` solo viene en planes comerciales (trial, Free, de pago): los internos no tienen facturación
export const hasCommercialPlan = (user) => Boolean(user?.agencyPlan);

// Las agencias externas usan el Setup recomendado, sin pack contratado
export const canSeeContractedPack = (user) => !isExternalAgency(user);

export const getSetupUnavailableMessage = (user) =>
  isExternalAgency(user)
    ? "Tu agencia no ha activado el Setup para este cliente."
    : "Contrata un pack para comenzar a visualizar tu itinerario.";

export const FEATURE_SEO_PROVIDER_BRANDING = "seo_provider_branding";

// Agencias sin el flag no ven el nombre del proveedor SEO: se muestra como "Datos SEO".
// `label` para títulos/botones; `source`/`Source` para usarlo dentro de una frase.
export const getSeoProvider = (user) =>
  hasAgencyFeature(user, FEATURE_SEO_PROVIDER_BRANDING)
    ? { branded: true, label: "SE Ranking", source: "SE Ranking", Source: "SE Ranking" }
    : {
      branded: false,
      label: "Datos SEO",
      source: "el proveedor de datos SEO",
      Source: "El proveedor de datos SEO",
    };

export const SEO_PERMISSION_MESSAGE = "Contacta con la administración para gestionar este permiso.";
